<template>
  <div>
    <b-card no-body border-variant="msstream" class="marginal">
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h5 class="m-0">
          <b-row class="align-items-center justify-content-center">
            <b-icon icon="images"></b-icon>&nbsp;
            {{ $ml.get("defaultoutrotitle") }}
            &nbsp;<b-badge>{{ outros.length }}</b-badge>
          </b-row>
        </h5>
      </b-card-header>
      <b-card-body>
        <b-form-select v-model="currentOutro" :options="outroOptions"></b-form-select>
        <div v-if="currentOutro" class="marginaltopsm">
          <p><strong>{{$ml.get('outrotitle')}}:</strong> {{currentOutro.title}}</p>
          <p><strong>{{$ml.get('outrodescription')}}:</strong> {{currentOutro.description}}</p>
          <p><strong>{{$ml.get('outrourl')}}:</strong> {{currentOutro.url}}</p>
          <p><strong>{{$ml.get('outrotext')}}:</strong> {{currentOutro.text}}</p>
          <p><strong>{{$ml.get('outrourl2')}}:</strong> {{currentOutro.url2}}</p>
          <p><strong>{{$ml.get('outrotext2')}}:</strong> {{currentOutro.text2}}</p>
          <b-row class="justify-content-center">
            <b-col lg="3" md="4" cols="6">
              <b-img :src="currentOutro.img_base" fluid></b-img>
            </b-col>
          </b-row>
        </div>
        <b-row v-if="currentOutro" class="align-items-center justify-content-around marginaltop">
          <b-col cols="auto">
            <b-button
              variant="msstreamblue"
              style="text-align: center; line-height: normal"
              @click="showModal('modifyOutro')"
            >
              {{ $ml.get("modifyoutro") }}
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="currentOutro" class="align-items-center justify-content-around marginaltop">
          <b-col cols="auto">
            <b-button
              variant="quanteec"
              style="text-align: center; line-height: normal"
              @click="showModal('confirmDeleteOutro')"
            >
              {{ $ml.get("removeoutro") }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="align-items-center justify-content-around marginaltop">
          <b-col cols="auto">
            <b-button
              class="pointerOrange"
              style="text-align: center; line-height: normal"
              @click="showModal('createOutro')"
            >
              {{ $ml.get("addanoutro") }}
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-modal ref="successNewPicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("picture") }}
        </h4>
      </div>
      <p
        style="line-height: normal; text-align: center"
        v-html="$ml.get('pictureuploadsuccess')"
      ></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="quanteeclg"
          @click="hideModal('successNewPicture')"
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'times']"
          />
          {{ $ml.get("close") }}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorNewPicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("picture") }}
        </h4>
      </div>
      <p
        style="line-height: normal; text-align: center"
        v-html="$ml.get('pictureuploaderror')"
      ></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="quanteeclg"
          @click="hideModal('errorNewPicture')"
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'times']"
          />
          {{ $ml.get("close") }}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDeleteOutro" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("outro") }}
        </h4>
      </div>
      <p
        style="line-height: normal; text-align: center"
        v-html="$ml.get('outrodeleteconfirm')"
      ></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          @click="
            hideModal('confirmDeleteOutro');
            deleteOutro(currentOutro);
          "
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'check']"
          />
          {{ $ml.get("delete") }}
        </b-btn>
        <b-btn
          class="col-md-3 col-5"
          variant="quanteeclg"
          @click="hideModal('confirmDeleteOutro')"
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'times']"
          />
          {{ $ml.get("close") }}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDeletePicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("picture") }}
        </h4>
      </div>
      <p
        style="line-height: normal; text-align: center"
        v-html="$ml.get('picturedeleteconfirm')"
      ></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="msstreamblue"
          @click="
            hideModal('confirmDeletePicture');
            deletePicture(currentPicture);
          "
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'check']"
          />
          {{ $ml.get("delete") }}
        </b-btn>
        <b-btn
          class="col-md-3 col-5"
          variant="quanteeclg"
          @click="hideModal('confirmDeletePicture')"
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'times']"
          />
          {{ $ml.get("close") }}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorDeletePicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          {{ $ml.get("picture") }}
        </h4>
      </div>
      <p
        style="line-height: normal; text-align: center"
        v-html="$ml.get('picturedeleteerror')"
      ></p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="quanteeclg"
          @click="hideModal('errorDeletePicture')"
        >
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'times']"
          />
          {{ $ml.get("close") }}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="modifyOutro" hide-footer hide-header @show="getPictures();">
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'link']"
          />
          <span>{{ $ml.get("outro") }}</span>
        </h4>
      </div>
      <b-form
        v-if="currentOutro"
        @submit.prevent="
          hideModal('modifyOutro');
          putOutro();
        "
      >
        <b-form-group
          :label="$ml.get('outrotitle') + ':'"
          label-for="outroTitle"
        >
          <b-form-input
            id="outroTitle"
            type="text"
            v-model="currentOutro.title"
            required
            :placeholder="$ml.get('outrotitle')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrodescription') + ':'"
          label-for="outroDescription"
        >
          <b-form-input
            id="outroDescription"
            type="text"
            v-model="currentOutro.description"
            required
            :placeholder="$ml.get('outrodescription')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrourl') + ':'"
          label-for="outroLinkButton"
        >
          <b-form-input
            id="outroLinkButton"
            type="text"
            v-model="currentOutro.url"
            required
            :placeholder="$ml.get('outrourl')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrotext') + ':'"
          label-for="outroLinkText"
        >
          <b-form-input
            id="outroLinkText"
            type="text"
            v-model="currentOutro.text"
            required
            :placeholder="$ml.get('outrotext')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group :label="$ml.get('outrourl2') + ':'" label-for="outroUrl2">
          <b-form-input
            id="outroUrl2"
            type="text"
            v-model="currentOutro.url2"
            
            :placeholder="$ml.get('outrourl2')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrotext2') + ':'"
          label-for="outroLinkText2"
        >
          <b-form-input
            id="outroLinkText2"
            type="text"
            v-model="currentOutro.text2"
            
            :placeholder="$ml.get('outrotext2')"
          >
          </b-form-input>
        </b-form-group>

        <div class="picture-grid picture-grid-size2 marginaltop">
          <div
            class="picture-item bg-msstream"
            v-for="picture in pictures"
            v-bind:key="picture.uuid"
          >
            <b-img
              :src="picture.url"
              fluid
              :title="picture.name"
              class="picture-item-img"
              :class="{ 'picture-selected': (picture.url === currentOutro.img_base) }"
              @click="currentOutro.img_base = picture.url"
            ></b-img>
          </div>
        </div>

        <b-row class="justify-content-around marginaltopsm">
          <b-btn class="col-md-5 col-5" variant="msstreamblue" type="submit">
            {{ $ml.get("Submit") }}</b-btn
          >
          <b-btn
            class="col-md-5 col-5"
            variant="quanteeclg"
            @click="hideModal('modifyOutro')"
          >
            {{ $ml.get("cancel") }}</b-btn
          >
        </b-row>
      </b-form>
    </b-modal>

    <b-modal ref="createOutro" hide-footer hide-header @show="getPictures();">
      <div class="d-block text-center">
        <h4 style="border-bottom: 1px solid #2a5d77; padding: 10px">
          <font-awesome-icon
            style="margin-right: 5px"
            :icon="['fas', 'link']"
          />
          <span>{{ $ml.get("outro") }}</span>
        </h4>
      </div>
      <b-form
        v-if="outro"
        @submit.prevent="
          hideModal('createOutro');
          postOutro();
        "
      >
        <b-form-group
          :label="$ml.get('outrotitle') + ':'"
          label-for="outroTitle"
        >
          <b-form-input
            id="outroTitle"
            type="text"
            v-model="outro.title"
            required
            :placeholder="$ml.get('outrotitle')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrodescription') + ':'"
          label-for="outroDescription"
        >
          <b-form-input
            id="outroDescription"
            type="text"
            v-model="outro.description"
            required
            :placeholder="$ml.get('outrodescription')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrourl') + ':'"
          label-for="outroLinkButton"
        >
          <b-form-input
            id="outroLinkButton"
            type="text"
            v-model="outro.url"
            required
            :placeholder="$ml.get('outrourl')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrotext') + ':'"
          label-for="outroLinkText"
        >
          <b-form-input
            id="outroLinkText"
            type="text"
            v-model="outro.text"
            required
            :placeholder="$ml.get('outrotext')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group :label="$ml.get('outrourl2') + ':'" label-for="outroUrl2">
          <b-form-input
            id="outroUrl2"
            type="text"
            v-model="outro.url2"
            
            :placeholder="$ml.get('outrourl2')"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          :label="$ml.get('outrotext2') + ':'"
          label-for="outroLinkText2"
        >
          <b-form-input
            id="outroLinkText2"
            type="text"
            v-model="outro.text2"
            
            :placeholder="$ml.get('outrotext2')"
          >
          </b-form-input>
        </b-form-group>

        <div class="picture-grid picture-grid-size2 marginaltop">
          <div
            class="picture-item bg-msstream"
            v-for="picture in pictures"
            v-bind:key="picture.uuid"
          >
            <b-img
              :src="picture.url"
              fluid
              :title="picture.name"
              class="picture-item-img"
              :class="{ 'picture-selected': (picture.url === outro.img_base) }"
              @click="outro.img_base = picture.url"
            ></b-img>
          </div>
        </div>

        <b-row class="justify-content-around marginaltopsm">
          <b-btn class="col-md-5 col-5" variant="msstreamblue" type="submit">
            {{ $ml.get("Submit") }}</b-btn
          >
          <b-btn
            class="col-md-5 col-5"
            variant="quanteeclg"
            @click="hideModal('createOutro')"
          >
            {{ $ml.get("cancel") }}</b-btn
          >
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { BASE_URL } from "@/services/base-url";
import PictureService from "@/services/picture.service";
import OutroService from "@/services/outro.service";
let pictureService = new PictureService();
let outroService = new OutroService();
export default {
  name: "Outro",
  components: {},
  data: function () {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      outros: [],
      pictures: [],
      pictureFile: null,
      currentOutro: null,
      outro: {
        title: "",
        description: "",
        url: "",
        text: "",
        text2: "",
        url2: "",
        img_base: "",
      },
      outroOptions: []
    };
  },
  mounted() {
    this.getPictures();
    this.getOutros();
  },
  computed: {},
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },

    getPictures() {
      pictureService
        .getPictures(
          {
            client: this.clientView,
            pagesize: 1000,
            sort: JSON.stringify({ createdAt: -1 }),
          },
          this.$auth.token()
        )
        .then((response) => {
          this.pictures = response._embedded;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOutros() {
      outroService
        .getOutros(
          {
            client: this.clientView,
            pagesize: 1000,
            sort: JSON.stringify({ title: 1 }),
          },
          this.$auth.token()
        )
        .then((response) => {
          this.outros = response._embedded;
          this.outroOptions = this.outros.map(x => {
            return {
              text: x.title,
              value: x
            }
          })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postOutro() {
      outroService
        .postOutro(this.outro, this.$auth.token())
        .then((response) => {
          this.getOutros();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    putOutro() {
      outroService
        .putOutro(this.currentOutro.uuid, this.currentOutro, this.$auth.token())
        .then((response) => {
          this.getOutros();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteOutro() {
      outroService
        .deleteOutro(this.currentOutro.uuid, this.$auth.token())
        .then((response) => {
          this.currentOutro = null;
          this.getOutros();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.picture-grid {
  display: grid;
  grid-gap: 10px;
  align-items: center;
  justify-content: center;
}

.picture-item {
  grid-column: span 1;
  position: relative;
  padding-top: 56.25%;
  width: 100%;
  transition: 0.15s all ease-in-out;
  &:hover {
    transform: scale(1.03);
  }
}

.picture-item {
  grid-column: span 1;
  position: relative;
  padding-top: 176px;
  width: 100px;
  transition: 0.15s all ease-in-out;
  &:hover {
    transform: scale(1.03);
  }
}

.picture-selected {
  border: 2px dashed red;
}

.picture-item-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.picture-grid-size {
  grid-template-columns: repeat(5, 1fr);
}

@media all and (min-width: 768px) {
  .picture-grid-size {
    grid-template-columns: repeat(10, 1fr);
  }
}
.picture-grid-size2 {
  grid-template-columns: repeat(4, 1fr);
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>